<div class="message-list-container">
  <div class="message-list-header">
    <div class="header-controls">
      <tn-input
        class="filter-field"
        testId="websocket-debug-filter"
        [placeholder]="'Filter by method' | translate"
        [(ngModel)]="filterText"
        (ngModelChange)="applyFilter()">
      </tn-input>
      <tn-checkbox
        testId="websocket-debug-auto-scroll"
        [tnTooltip]="'Auto-scroll to latest message' | translate"
        [label]="'Auto-scroll' | translate"
        [(ngModel)]="autoScroll"
      ></tn-checkbox>
      <tn-checkbox
        testId="websocket-debug-duplicate-notifications"
        [tnTooltip]="'Show snackbar when duplicate API calls are detected' | translate"
        [label]="'Duplicate alerts' | translate"
        [ngModel]="duplicateNotificationsEnabled()"
        (ngModelChange)="toggleDuplicateNotifications()"
      ></tn-checkbox>
      <tn-icon-button
        name="delete-outline"
        library="mdi"
        class="clear-button"
        testId="websocket-debug-clear-messages"
        [tooltip]="'Clear messages' | translate"
        [ariaLabel]="'Clear messages' | translate"
        (onClick)="clearMessages()"
      ></tn-icon-button>
    </div>
  </div>

  @if (!hasMessages) {
    <tn-empty
      class="empty-state"
      icon="message-text-outline"
      iconLibrary="mdi"
      iconSize="48px"
      [title]="'No messages yet' | translate"
    ></tn-empty>
  } @else {
    <div #messageViewport class="message-viewport">
      @for (message of filteredMessagesArray; track message.id) {
        <div class="message-item"
             [class.outgoing]="message.direction === MessageDirection.Out"
             [class.incoming]="message.direction === MessageDirection.In"
             [class.mocked]="message.isMocked"
             [class.expanded]="message.isExpanded">
          
          <div class="message-header">
          <span class="direction-icon">
            @if (message.direction === MessageDirection.Out) {
              <tn-icon name="arrow-right" library="mdi" class="icon-out"></tn-icon>
            } @else {
              <tn-icon name="arrow-left" library="mdi" class="icon-in"></tn-icon>
            }
          </span>
          
          <span class="method-name">{{ message.methodName }}</span>
          
          @if (message.isMocked) {
            <span class="mocked-badge">{{ 'MOCKED' | translate }}</span>
          }
          
          <span class="timestamp">{{ message.formattedTime }}</span>
          
          @if (canCreateMock(message)) {
            <tn-icon-button
              name="plus"
              library="mdi"
              class="mock-button"
              testId="websocket-debug-create-mock"
              [tooltip]="'Create mock from response' | translate"
              [ariaLabel]="'Create mock from response' | translate"
              (onClick)="createMockFromMessage(message); $event.stopPropagation()"
            ></tn-icon-button>
          }

          <tn-icon-button
            name="content-copy"
            library="mdi"
            class="copy-button"
            testId="websocket-debug-copy-message"
            [tooltip]="'Copy message' | translate"
            [ariaLabel]="'Copy message' | translate"
            (onClick)="copyMessage(message); $event.stopPropagation()"
          ></tn-icon-button>

          <tn-icon-button
            library="mdi"
            class="toggle-button"
            testId="websocket-debug-toggle-message"
            [tooltip]="'Toggle message details' | translate"
            [name]="message.isExpanded ? 'chevron-down' : 'chevron-right'"
            [ariaLabel]="message.isExpanded
              ? ('Collapse message details' | translate)
              : ('Expand message details' | translate)"
            [ariaExpanded]="message.isExpanded"
            (onClick)="toggleMessage(message.id)"
          ></tn-icon-button>
        </div>
        
        @if (!message.isExpanded) {
          <div class="message-preview">
            {{ message.messagePreview }}
          </div>
        }
        
        @if (message.isExpanded) {
          <div class="message-expanded">
            <ix-code-editor
              [ngModel]="message.message | json"
              [ngModelOptions]="{ standalone: true }"
              [language]="CodeEditorLanguage.Json"
              [disabled]="true"
              [ariaLabel]="'Message JSON' | translate"
            ></ix-code-editor>
          </div>
        }
      </div>
      }
    </div>
  }
</div>